/*
 * Validate length range. It Overrides the default one with a possible delegation to a custom lenght evaluator
 */
 $.formUtils.addValidator({
     name : 'length',
     validatorFunction : function(val, $el, conf, lang) {
         var lengthAllowed = $el.valAttr('length'),
             type = $el.attr('type');

         if(lengthAllowed == undefined) {
             var elementType = $el.get(0).nodeName;
             alert('Please add attribute "data-validation-length" to '+elementType+' named '+$el.attr('name'));
             return true;
         }
         // check if exists a specific field lenght evaluator, if so use it!
         let fnValueLength = $el.data('fn-lenght-evaluator');
         
         // check if length is above min, below max or within range.
         let len = (type == 'file' && $el.get(0).files !== undefined) ? $el.get(0).files.length : (typeof fnValueLength === 'function') ? fnValueLength(val): val.length;
         let lengthCheckResults = $.formUtils.numericRangeCheck(len, lengthAllowed);
         let checkResult;

         switch(lengthCheckResults[0])
         {   // outside of allowed range
             case "out":
                 this.errorMessage = lang.lengthBadStart + lengthAllowed + lang.lengthBadEnd;
                 checkResult = false;
                 break;
             // too short
             case "min":
                 this.errorMessage = lang.lengthTooShortStart + lengthCheckResults[1] + lang.lengthBadEnd;
                 checkResult = false;
                 break;
             // too long
             case "max":
                 this.errorMessage = lang.lengthTooLongStart + lengthCheckResults[1] + lang.lengthBadEnd;
                 checkResult = false;
                 break;
             // ok
             default:
                 checkResult = true;
         }
         
         return checkResult;
     },
     errorMessage : '',
     errorMessageKey: ''
 });